import React from 'react';
import ExamProxy from './adapter/ExamProxy';
import utils from '@seeing/utils';
import {Tabs} from 'zarm';
// 检查的布局
import * as ExamLayouts from './layout';

class ExamItem extends React.Component {
  static defaultProps = {
    data: {}, // 检查项的数据
  };
  constructor(props) {
    super(props);
    const {data = {}} = props;
    const {examConfig = {}} = data;
    this.state = {
      config: examConfig, // 配置
      data,
      submitValues: {}, // 提交的数据
    };
  }
  componentDidMount() {}

  /**
   * 处理最终的数据
   * @param {*} value
   */
  handleFinishCallback = () => {
    return this.examItemLayoutRef.handleResult();
  };

  render() {
    // 检查项的配置
    const {config = {}, data = {}} = this.state;
    // 检查项布局
    const {examLayout} = config;
    // 检查项的布局组件
    const ExamItemLayout = ExamLayouts[examLayout];
    return (
      <div className="examContainer">
        {ExamItemLayout && (
          <ExamItemLayout
            {...this.props}
            config={config}
            data={data}
            ref={(ref) => (this.examItemLayoutRef = ref)}
            handleResult={this.handleResult}
          />
        )}
      </div>
    );
  }
}
export default ExamItem;
